<script lang="ts">
    import { writable } from 'svelte/store';
    import { setSecuredAreaModalOpenState } from '$components/Context/SecuredAreaModalContext';
    import ModalSecuredArea, {
        createModal,
    } from '$components/SecuredArea/ModalSecuredArea.svelte';

    const open = writable<boolean>(false);
    setSecuredAreaModalOpenState(open);

    let modal = createModal({ open });
</script>

<slot />

<ModalSecuredArea {modal} />
